import React, { useEffect } from 'react'

import queryString from 'query-string'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import type { RootState } from 'reducers'

import { me } from 'actions/auth-actions'
import { useAppDispatch } from 'hooks/useAppDispatch'

const Authentication =
  (BaseComponent: React.ElementType) =>
  ({ auth, ...props }: any) => {
    const dispatch = useAppDispatch()
    const authenticated = useSelector((s: RootState) => s.auth.authenticated)

    useEffect(() => {
      if (!auth) return
      dispatch(me())
    }, [authenticated])

    if (!auth || authenticated) return <BaseComponent auth={auth} {...props} />
    if (authenticated === null) return null

    return (
      <Navigate
        replace
        to={{
          pathname: '/login',
          search: queryString.stringify({
            next: window.location.pathname !== '/' ? window.location.pathname : undefined,
          }),
        }}
      />
    )
  }

export default Authentication
